import React from "react";
import SideBar from "./SideBar";
import Router from "./Router";

import styled from "styled-components";
const Root = () => {
  return (
    <Container>
      <Section flexBasis={0}>
        <SideBar />
      </Section>

      <Section flexBasis={100} padding={10}>
        {/* <Header /> */}
        <Router />
      </Section>
    </Container>
  );
};

export default Root;

const Container = styled.div`
  display: flex;
  background-color: #f9fafb;
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-basis: ${(props) => props.flexBasis + "%"};
  padding-left: ${(props) => props.padding + "px"};
  padding-right: ${(props) => props.padding + "px"};
`;
